import {
  BULK_SPLIT_SHIP,
  useGroupedPrice,
  useProject,
} from '@customink/project-service-react-components';
import type { ProjectItem as ProjectItemType } from '@customink/project-service-react-components';
import { SHIPPING_TYPES, TURN_TIMES } from '@customink/project-service-types';
import type { TurnTime } from '@customink/project-service-types';

import {
  DEFAULT_PRICE,
  totalIndividualShippingFee,
} from '@/components/ProjectItemList/util';
import { shippingDeliveryOption } from '@/utils/shippingDeliveryOption';

const { MIN_ADDRESS_COUNT } = BULK_SPLIT_SHIP;

export const useGroupDeliveryFee = (
  designCid: string,
  projectItems: ProjectItemType[],
) => {
  const { data: projectData } = useProject();
  const groupedPrices = useGroupedPrice(designCid);

  // BULK / INDIVIDUAL
  const projectShippingType = projectData?.configuration?.shippingType;
  const defaultTurnTime: TurnTime = shippingDeliveryOption(projectItems);
  const originalAddressCount = projectData?.distributedOrder?.numberOfAddresses;

  // if still loading data
  if (!groupedPrices) return undefined;

  // if BULK (or undefined and we assume BULK as a default)
  if (projectShippingType === SHIPPING_TYPES.BULK || !projectShippingType) {
    const rush = groupedPrices.rush_shipping?.delivery_price || DEFAULT_PRICE;
    const superRush =
      groupedPrices.super_rush_shipping?.delivery_price || DEFAULT_PRICE;

    return {
      [TURN_TIMES.SUPERRUSH]: superRush,
      [TURN_TIMES.RUSH]: rush,
      [TURN_TIMES.STANDARD]: DEFAULT_PRICE,
      [TURN_TIMES.QUICKER]: DEFAULT_PRICE, // required for type safety
    }[defaultTurnTime];
  }

  if (projectShippingType === SHIPPING_TYPES.INDIVIDUAL) {
    return totalIndividualShippingFee(
      originalAddressCount || MIN_ADDRESS_COUNT,
    );
  }
};
